import termsOfUseHtml from "../assets/Legal/TermsOfUse.md?html";
import { createRoute } from "../lib/createRoute";
import LegalMarkdown from "../pages/LegalMarkdown";

export const Route = createRoute(
  "/terms-of-use",
  () => <LegalMarkdown htmlText={termsOfUseHtml} />,
  "Terms of Use | Flowstep",
  "Flowstep's Terms of Use explain the rules and conditions for using our AI design tool and website.",
);
